/* eslint-disable no-console */
import {
  Wrap,
  StyledPopupConfigureLabel,
} from './styles';

import ConfigureLabel from '../ConfigureLabel';

import Icon from '@map/components/Icons';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**  
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
import { useMap } from 'views/MapView/hooks';

const HideAndConfigureLabel = ({ 
  initialValues, 
  onFormConfigureLabel, 
  layer, 
  selectedColumn,
  isShowInputCell,
  setEditColumn,
  setEditColumnType
}) => {
  
  const [anchorElConfigureLabel, setAnchorElConfigureLabel] = useState(null);
  const {    
    configureVisibilityLabel,    
  } = useMap();

  /**
   * Método para abertura do popup de configuração dos rótulos
   *
   * @param {object} event
   */
  const openPopupConfigureLabel = (event) => {
    setAnchorElConfigureLabel(event.currentTarget);
  };

  /**
   * Método para fechar o popup de configuração dos rótulos
   */
  const handleClosePopupFormConfigureLabel = () => {
    setAnchorElConfigureLabel(null);
    setEditColumn(null);
    setEditColumnType(null);
  };


  return (
    <Wrap>
      <div className="config-label-actions active">
        <Tooltip 
          title={`${
            layer.statusLabelVisibility
               ? 'Ocultar'
               : 'Exibir'
          } rótulo`}
        >
          <button
            className="config-label-action"            
            onClick={(e) => {
              e.stopPropagation();
              if (layer.selectedLabelColumn && layer.visible) {
                configureVisibilityLabel(layer.id);
              }
            }}
          >            
            <Icon 
              i={`${
                layer.statusLabelVisibility
                  ? 'map-closedeye'
                  : 'map-eye'
              }`}              
              width='17px'
              fill={`${
                layer.selectedLabelColumn && layer.visible
                  ? ''
                  : '#b6b6b6'
              }`}
              stroke={`${
                layer.selectedLabelColumn && layer.visible
                  ? ''
                  : '#b6b6b6'
              }`}
            />
          </button>
        </Tooltip>
        <Tooltip 
          title="Configurar rótulo"
        >
          <button
            className="config-label-action"            
            onClick={(e) => {
              e.stopPropagation();              
              openPopupConfigureLabel(e);
              
            }}
          >            
            <Icon
              i="map-editSymbology"
              fill={
                (selectedColumn || layer.selectedLabelColumn)
                  && !isShowInputCell ? '#3c71dd' : '#797e82'              
              }                      
            />
          </button>
        </Tooltip>        
      </div>
      <StyledPopupConfigureLabel
        id="popup-configure-label"
        anchorEl={anchorElConfigureLabel}
        open={Boolean(anchorElConfigureLabel)}
        onClose={handleClosePopupFormConfigureLabel}
        anchorOrigin={{
          vertical: -21,
          horizontal: 'right',
        }}
      >        
        <ConfigureLabel
          initialValues={initialValues}
          onFormConfigureLabel={onFormConfigureLabel}
          onClose={handleClosePopupFormConfigureLabel}
        />
      </StyledPopupConfigureLabel>
    </Wrap>
  );
};

HideAndConfigureLabel.properties = {
  ignore: true,
};

export default HideAndConfigureLabel;
